<template>
  <div class="note-page-wrap">
    <!-- <div class="test" @click="onClickInsertImg">插入图片</div>
    <div class="test" @click="onClickInsertMark">插入mark</div> -->
    <wang-editor
      ref="editor"
      class="editor"
      :value="noteInfo.content || ''"
      placeholder="请填写您的笔记"
      :toolbarKeys="toolbarKeys"
      :readOnly="true"
      @input="onChange"
      @created="onEditorCreated"
      @noticeJumpPlayTime="noticeJumpPlayTime"
      @keydown.native="onKeydown"
      @noticeMarkBlockUploadStatus="noticeMarkBlockUploadStatus"
      @noticeImageUploadStatus="noticeImageUploadStatus"
      :lessonInfo="handleLessonInfo"
    ></wang-editor>
  </div>
</template>

<script>
import WangEditor from "@saas/components/src/components/wang-editor/Index.vue";
import { getNoteDetail, saveNote, exportNote } from "@saas/service-api/src/note";
import { extractTextFromHtml } from "@saas/components/src";
import { isHXApp, isH5, isMGAppInPad } from "@saas/components";
import { jsToFlutter } from "@saas/components/src/utils/js-to-flutter";
import { EventBus } from "@saas/components/src/utils/event-bus";
import { convertBase64ToFile, videoMarkPopover } from "@saas/components";
export default {
  data() {
    return {
      isElectron: window.isElectron,
      lessonId: null,
      courseId: null,
      unitId: null,
      toolbarKeys: ["insertFormula", "bold", "italic", "underline"],
      editor: null,
      noteInfo: {},
      saving: false,
      exporting: false,
      isHXApp: isHXApp(),
      scrollSwitch: false,
      isInit: false,
    };
  },
  components: {
    WangEditor,
  },
  mounted() {
    this.lessonId = Number(this.$route.params.lessonId);
    this.courseId = this.$route.params.courseId;
    this.unitId = Number(this.$route.params.unitId);
    if (this.isHXApp) {
      jsToFlutter("getToken");
      EventBus.$off("setToken");
      EventBus.$on("setToken", (isLogin) => {
        if (isLogin) {
          this.apiGetNoteDetail();
        }
      });
    } else {
      this.apiGetNoteDetail();
    }
    window.noteInsertContent = (params) => {
      try {
        this.isInit = true;
        const { type, data } = JSON.parse(params);
        if (type === "image") {
          // 插入图片
          this.scrollSwitch = true;
          this.insertImage(data.img);
        } else if (type === "mark") {
          // 插入标记块
          this.scrollSwitch = true;
          this.insertMarkBlock(data);
        }
      } catch (e) {
        console.log(e);
      }
    };
  },
  methods: {
    onChange() {
      // console.log("onChange》〉》〉》〉》〉》");
      if (!this.isInit) {
        return;
      }
      this.apiSaveNote();
    },
    noticeMarkBlockUploadStatus(data) {
      if (["loading", "loaded"].includes(data.status) && this.scrollSwitch) {
        this.$nextTick(() => {
          this.$refs.editor.scrollToBottom();
          this.switchScroll = false;
        });
      }
    },
    noticeImageUploadStatus(data) {
      if (data.status === "loading" && this.scrollSwitch) {
        this.$nextTick(() => {
          this.$refs.editor.scrollToBottom();
          this.switchScroll = false;
        });
      }
    },

    onClickInsertImg() {
      const params = JSON.stringify({
        type: "image",
        data: {
          img: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAALCAYAAACZIGYHAAAAAXNSR0IArs4c6QAAAeRJREFUKFN10b1rU2EUx/HveW6ae32hSRSF2q0guGiXIrZ0KegfIZQacAglGoSCVRS8oVWyWOudmtqa+kKHDP4FDgHBwUVUfEGLxcFFSzA0kqTJvUdv2ki19mxn+Ty/33lkembhpBGZUNXnTbux6KbTPwFl11HJ5ea7fce6KjCsBFNy6+69kqgMKdQVnYo0zNzk5Pnq/yBVlezsUqxLguuCjgM26Bu5ObvwTGAQMAoVUc02rNr9bCazvh0KgVxuOa5O7QrCuMB+RX2Qp5K7PdcfWJHHwDHAAsqqemPD2vMomxltQ+0EdxYTUaMTqKQRuoEW8MI3/jnJ5/Nd5XVzQi2WEfpADMiaiF6ri1OU8krVPnw0pvXaJQwXgATQBH1FJDq6sbb6WcL7uW4xasd/9CumCPRuJfpukMvQKgVYyd8JM8CBNqC8t9CztcrXT67rttpIOBc9z+7x9w4ghNU60DegpHBaNoGwwgdjZKx+vO+tOzIS7vxBwsXzPLuKc4pAHgJHQMIbhd8tIGGFjyKaXHWC1/OpVLMT4C9ks5rr2LHeIRUegPRsVWsqrGhA8tA+/2VqG7AjSUd23YJjxZrDlsgSIgdV+RIxjMXtncCuSDtRoeA4lWAgQM8YI08Sduvdvwk6j/4CqEPFQFSDu7AAAAAASUVORK5CYII=",
        },
      });
      window.noteInsertContent(params);
    },
    onClickInsertMark() {
      const params = JSON.stringify({
        type: "mark",
        data: {
          time: 111,
          markType: "key",
          img: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAALCAYAAACZIGYHAAAAAXNSR0IArs4c6QAAAeRJREFUKFN10b1rU2EUx/HveW6ae32hSRSF2q0guGiXIrZ0KegfIZQacAglGoSCVRS8oVWyWOudmtqa+kKHDP4FDgHBwUVUfEGLxcFFSzA0kqTJvUdv2ki19mxn+Ty/33lkembhpBGZUNXnTbux6KbTPwFl11HJ5ea7fce6KjCsBFNy6+69kqgMKdQVnYo0zNzk5Pnq/yBVlezsUqxLguuCjgM26Bu5ObvwTGAQMAoVUc02rNr9bCazvh0KgVxuOa5O7QrCuMB+RX2Qp5K7PdcfWJHHwDHAAsqqemPD2vMomxltQ+0EdxYTUaMTqKQRuoEW8MI3/jnJ5/Nd5XVzQi2WEfpADMiaiF6ri1OU8krVPnw0pvXaJQwXgATQBH1FJDq6sbb6WcL7uW4xasd/9CumCPRuJfpukMvQKgVYyd8JM8CBNqC8t9CztcrXT67rttpIOBc9z+7x9w4ghNU60DegpHBaNoGwwgdjZKx+vO+tOzIS7vxBwsXzPLuKc4pAHgJHQMIbhd8tIGGFjyKaXHWC1/OpVLMT4C9ks5rr2LHeIRUegPRsVWsqrGhA8tA+/2VqG7AjSUd23YJjxZrDlsgSIgdV+RIxjMXtncCuSDtRoeA4lWAgQM8YI08Sduvdvwk6j/4CqEPFQFSDu7AAAAAASUVORK5CYII=",
        },
      });
      window.noteInsertContent(params);
    },
    apiSaveNote() {
      // console.log("保存笔记");
      // console.log("保存笔记--参数 course_id", this.courseId);
      // console.log("保存笔记--参数 saving", this.saving);
      if (!this.courseId) {
        return;
      }
      if (this.saving) {
        return;
      }
      this.saving = true;
      // const { course_id, lesson_id, unit_id } = this.noteInfo;
      let params = {
        content: this.editor.getHtml(),
        course_id: this.courseId,
        lesson_id: this.lessonId,
        unit_id: this.unitId,
        summary: extractTextFromHtml(this.editor.getHtml())?.text,
      };
      saveNote(params)
        .then((res) => {
          if (res.code === 1) {
            jsToFlutter("saveNotesResult", {
              isSuccess: 1,
            });
          } else {
            this.$message.error(res.message);
            jsToFlutter("saveNotesResult", {
              isSuccess: 2,
            });
          }
          this.saving = false;
        })
        .catch(() => (this.saving = false));
    },
    onKeydown(e) {
      e.stopPropagation();
    },
    onEditorCreated(editor) {
      this.editor = editor;
    },
    // 跳转到指定时间
    noticeJumpPlayTime(time) {
      console.log("跳转到指定时间", time);
      jsToFlutter("notesClick", { time });
    },
    async apiGetNoteDetail() {
      let params = { lesson_id: this.lessonId };
      const res = await getNoteDetail(params);
      console.log(res);
      if (res.code === 1) {
        this.noteInfo = res.data || { content: "" };
      } else {
        this.$message.error(res.message);
      }
    },
    apiExportNote() {
      this.loading = this.$loading({
        lock: true,
        text: "PDF生成中",
        spinner: "el-icon-loading",
        background: "rgba(255,255,255,.6)",
        fullscreen: true,
      });
      let params = {
        id: this.noteInfo.id,
      };
      exportNote(params)
        .then((res) => {
          if (res.code === 1) {
            this.$message.success("PDF生成成功");
            // todo 先直接打开
            if (this.isElectron) {
              window.openUrlByExternal(res.data);
            } else {
              window.open(res.data);
            }
          } else {
            this.$message.error(res.message || "PDF生成失败，请重新下载");
          }
          this.stopLoading();
        })
        .catch(() => {
          this.stopLoading();
          this.$message.error("PDF生成失败，请重新下载");
        });
    },
    stopLoading() {
      this.loading && this.loading.close();
    },
    insertImage(img) {
      // 判断img 是否是base64
      // 判断是否是file 对象类型
      if (this.editor) {
        if (img.startsWith("data:image")) {
          const file = convertBase64ToFile(img, "`screen-shot.png`");
          console.log("file", file);
          this.editor.emit("xhInsertImage", {
            file,
          });
        } else if (img instanceof File) {
          this.editor.emit("xhInsertImage", {
            file: img,
          });
        } else {
          this.editor.emit("xhInsertImage", {
            url: img,
          });
        }
      }
    },
    insertMarkBlock(params) {
      const file = convertBase64ToFile(params.img, "`screen-shot.png`");
      const data = {
        type: params.markType,
        time: params.time,
        file: file,
        content: params.markType === "key" ? "重点" : "疑问点",
      };
      console.log(data);
      this.editor.emit("xhInsertMarkBlock", data);
    },
  },
  computed: {
    handleLessonInfo() {
      // const { id, course_id, unit_id } = this.noteInfo;
      return {
        lesson_id: this.lessonId,
        course_id: this.courseId,
        unit_id: this.unitId,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.note-page-wrap {
  height: 100vh;
  overflow-y: hidden;
  display: flex;
  flex-direction: column;
}
.editor ::v-deep {
  flex: 1;
  // height: 100%;
  border: none;
  background: #fff;
  overflow: hidden;
  .comp-container__editor-toolbar {
    display: none;
  }
  .comp-container__editor-content {
    flex: 1;
    overflow-y: auto;
    .w-e-text-container {
      background: transparent;
    }
    .w-e-scroll {
      &::-webkit-scrollbar {
        width: 4px;
      }
      &::-webkit-scrollbar-thumb {
        background: transparent;
        border-radius: 2px;
      }
    }
  }
}

.note-page-wrap {
  background: #f7f8fa;
  .note-page-cont {
    display: flex;
    flex-direction: column;
    width: 1300px;
    background: #e5e6eb;
    margin: 0 auto;
    border-radius: 12px 12px 0 0;
    overflow: hidden;
    height: calc(100vh - 20px);
    box-sizing: border-box;
  }
  .note-title {
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-left: 22px;
    padding-right: 18px;
    background: #fff;

    .lesson-name {
      font-weight: 500;
      font-size: 16px;
      color: #1d2129;
      line-height: 22px;
      flex: 1;
      margin-right: 15px;
    }
    .download-btn {
      font-size: 22px;
      font-weight: bold;
      color: #1d2129;
      img {
        width: 20px;
        height: 20px;
      }
    }
  }
}
</style>
